import localeId from '@angular/common/locales/id';
import localeEn from '@angular/common/locales/en';
import { id, enUS, Locale } from 'date-fns/locale';

export const locale: { [ id: string ]: Locale } = {
  EN: enUS,
  ID: id
};

export const ngLocale: { [ id: string ]: any } = {
  EN: localeEn,
  ID: localeId
};
